export default __webpack_public_path__ + "static/media/extract.ca5ae752.svg";